import React from 'react'

const NothingSelected = () => {
    return (
        <div className='nothing__main-content'>
            <p>
                Select something
                <br />
                or create a new entry
            </p>

            <i className='far fa-star fa-4x mt-5'></i>
        </div>
    )
}

export default NothingSelected